import SharedPropsService from "../../SharedPropsService";
import { ROUTE } from "../../routes";
import { partnerApi } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
let name = "";
let email = "";
export const saveName = async (action, _datastore, { network, setDatastore, navigate }) => {
    await setDatastore(action.routeId, "continue", {
        loading: true,
    });
    const accountId = (await SharedPropsService.getUser())
        .linkedPartnerAccounts[0].accountId;
    const response = await network.patch(`${partnerApi.accountAttributes}${accountId}`, {
        partnerName: name,
        accountHolderEmail: email,
    }, { headers: await getAppHeader() });
    // api call end
    await setDatastore(action.routeId, "continue", {
        loading: false,
    });
    const updatedUser = response.data;
    if (updatedUser) {
        await navigate(ROUTE.DISTRIBUTOR_CLIENT_LIST);
    }
};
export const textOnChange_name = async (action, _datastore, {}) => {
    name = action.payload.value;
};
export const textOnChange_email = async (action, _datastore, {}) => {
    email = action.payload.value;
};
export const goBack = async (action, _datastore, { navigate }) => {
    navigate(ROUTE.EMAIL_VERIFY);
};
